var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalizedLearningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.941,
    height: 26.32,
    viewBox: "0 0 34.941 26.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.26,1151.158a.75.75,0,0,1-.75-.75v-19.046a1.088,1.088,0,0,0-1.086-1.086H189.487a1.088,1.088,0,0,0-1.086,1.086v19.046a.75.75,0,0,1-1.5,0v-19.046a2.589,2.589,0,0,1,2.586-2.586h24.936a2.589,2.589,0,0,1,2.586,2.586v19.046A.75.75,0,0,1,216.26,1151.158Z",
    transform: "translate(-185.235 -1129.526)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.867,1166.879H185.326a2.2,2.2,0,0,1-2.2-2.2v-3.169h34.941v3.169A2.2,2.2,0,0,1,215.867,1166.879Zm-31.241-3.868v1.669a.7.7,0,0,0,.7.7h30.542a.7.7,0,0,0,.7-.7v-1.669Z",
    transform: "translate(-183.876 -1141.309)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.596 2.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.215,1143.919a5.978,5.978,0,0,1,5.971,5.972v.893a1.665,1.665,0,0,1-1.643,1.642h-8.657a1.665,1.665,0,0,1-1.643-1.642v-.893a5.95,5.95,0,0,1,5.972-5.972Zm4.329,7.007c.043,0,.143-.075.143-.142v-.893a4.472,4.472,0,1,0-8.943,0v.893c0,.042.076.142.143.142Z",
    transform: "translate(-201.993 -1137.707)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.193,1133.042a4.231,4.231,0,1,1-4.231,4.231A4.236,4.236,0,0,1,208.193,1133.042Zm0,6.962a2.731,2.731,0,1,0-2.731-2.73A2.734,2.734,0,0,0,208.193,1140Z",
    transform: "translate(-202.972 -1133.792)",
    fill: "#6b19ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizedLearningIcon);
export default __webpack_public_path__ + "static/media/personalized-learning-icon.470454daee5c6bd1d9b25b82cdfcbba4.svg";
export { ForwardRef as ReactComponent };